import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useScrollToTop } from "@/hooks/useScrollToTop";
import AboutHero from "./components/AboutHero";
import HeritageTimeline from "./components/HeritageTimeline";
import CraftsmanshipSection from "@/pages/home/components/CraftsmanshipSection";
import TestimonialsSection from "@/pages/home/components/TestimonialsSection";
import ContactSection from "@/pages/home/components/ContactSection";

export default function About() {
  useScrollToTop();
  return (
    <div className="min-h-screen bg-brand-cream font-sans">
      <Navbar />
      <main className="pt-0">
        <AboutHero />
        <HeritageTimeline />
        <CraftsmanshipSection />
        <TestimonialsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
